module.exports = function getResource(label, vars = []) {
    const resources = {
        pausePlayAnimationLabel: `${vars[0] ? 'Pause': 'Play'} animation`,
        previous: 'Previous',
        next: 'Next'
    };

    return resources[label];
};
